export const ACCOUNT_MENU_ID = 'account-menu'
